function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3714",
  "data-name": "Group 3714",
  transform: "translate(-543 -499)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(543 499)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_22_Copy",
  "data-name": "Group 22 Copy"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Bg",
  width: 24,
  height: 24,
  rx: 12,
  fill: "#cc96f1"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3316",
  "data-name": "Group 3316",
  transform: "translate(-3723.572 -1468.871)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_385",
  "data-name": "Path 385",
  d: "M4279.307,1990.643l.707-6.306,2.01-1.5,4.431-.632,5.013,1.078,1.6,3.994-.855,4.93-2.1,2.083-5.073.372-2.231,2.417-.334-.315-.149-2.7-2.56-1.673Z",
  transform: "translate(-7.416 -8.397)",
  fill: "#7360f2"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3315",
  "data-name": "Group 3315",
  transform: "translate(4271.309 1973.146)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_386",
  "data-name": "Path 386",
  d: "M4284.559,1974.68c-.391-.362-1.971-1.509-5.488-1.523,0,0-4.15-.252-6.187,1.6-1.128,1.128-1.523,2.775-1.566,4.817s-.1,5.869,3.593,6.906h0v1.585s0,.643.4.771c.51.162.809-.328,1.3-.852.267-.291.638-.714.914-1.038a14.193,14.193,0,0,0,4.683-.343,4.618,4.618,0,0,0,3.864-4.365C4286.572,1978.3,4285.853,1975.8,4284.559,1974.68Zm.429,7.282a3.661,3.661,0,0,1-3.166,3.531,13.038,13.038,0,0,1-4.032.347s-1.6,1.9-2.1,2.427a.271.271,0,0,1-.228.1c-.086-.024-.11-.124-.11-.271v-2.632h0c-3.123-.871-2.941-4.127-2.9-5.831a5.635,5.635,0,0,1,1.309-4.046c1.708-1.547,5.235-1.318,5.235-1.318,2.975,0,4.4.909,4.731,1.209,1.108.942,1.665,3.189,1.261,6.487Z",
  transform: "translate(-4271.308 -1973.146)",
  fill: "#e5e1ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_387",
  "data-name": "Path 387",
  d: "M4380.1,2042.241a.2.2,0,0,1-.2-.19.952.952,0,0,0-.861-1.035.941.941,0,0,0-.139,0,.2.2,0,1,1,.023-.4,1.337,1.337,0,0,1,1.378,1.3c0,.044,0,.088,0,.132a.2.2,0,0,1-.19.209h0Z",
  transform: "translate(-4370.896 -2035.7)",
  fill: "#e5e1ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_388",
  "data-name": "Path 388",
  d: "M4377,2028.963h0a.2.2,0,0,1-.195-.2h0a2.3,2.3,0,0,0-.595-1.68,2.479,2.479,0,0,0-1.732-.757.2.2,0,1,1,.028-.4,2.89,2.89,0,0,1,2,.881,2.7,2.7,0,0,1,.69,1.942.2.2,0,0,1-.175.213Z",
  transform: "translate(-4366.767 -2022.079)",
  fill: "#e5e1ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_389",
  "data-name": "Path 389",
  d: "M4373.835,2016.029a.2.2,0,0,1-.2-.2,3.807,3.807,0,0,0-1.071-2.856,3.664,3.664,0,0,0-2.637-1.042.2.2,0,0,1,0-.4h0a4.074,4.074,0,0,1,2.913,1.156,4.227,4.227,0,0,1,1.189,3.122.2.2,0,0,1-.2.2Z",
  transform: "translate(-4362.561 -2008.735)",
  fill: "#e5e1ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_390",
  "data-name": "Path 390",
  d: "M4322.55,2023.535a.543.543,0,0,0,.429-.162l.295-.371a.638.638,0,0,1,.814-.109,8.422,8.422,0,0,1,.732.476c.225.167.677.542.677.547a.557.557,0,0,1,.118.733h0a3.079,3.079,0,0,1-.609.752h0a1.21,1.21,0,0,1-.623.3.258.258,0,0,1-.091,0,.828.828,0,0,1-.262-.038h0a9.3,9.3,0,0,1-1.7-.79,10.029,10.029,0,0,1-1.428-.952,7.581,7.581,0,0,1-.643-.571h-.023a8.31,8.31,0,0,1-.571-.647,10.344,10.344,0,0,1-.952-1.428,9.035,9.035,0,0,1-.785-1.7h0a.854.854,0,0,1-.043-.267.468.468,0,0,1,0-.091,1.194,1.194,0,0,1,.3-.619h0a3.094,3.094,0,0,1,.672-.728h0a.561.561,0,0,1,.737.119s.38.476.543.676a8.049,8.049,0,0,1,.476.733.653.653,0,0,1-.114.819l-.371.29a.551.551,0,0,0-.162.433A3.851,3.851,0,0,0,4322.55,2023.535Z",
  transform: "translate(-4314.488 -2014.528)",
  fill: "#e5e1ff"
}))));

var SvgViber = function SvgViber(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViber, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/viber.f2a3ff59.svg";
export { ForwardRef as ReactComponent };